// Constantes operacionais do cockpit do imóvel (ImovelShow).
// Extraídas da página para manter o arquivo navegável sem alterar contratos.

export const DETAIL_SECTIONS = [
  { id: 'resumo', label: 'Resumo', icon: 'i-lucide-layout-dashboard' },
  { id: 'fotos', label: 'Fotos', icon: 'i-lucide-images' },
  { id: 'mapa', label: 'Mapa', icon: 'i-lucide-map-pin' },
  { id: 'valores', label: 'Valores', icon: 'i-lucide-badge-dollar-sign' },
  { id: 'taxas', label: 'Taxas', icon: 'i-lucide-receipt-text' },
  { id: 'identidade', label: 'Identidade', icon: 'i-lucide-fingerprint' },
  { id: 'versionamento', label: 'Versões', icon: 'i-lucide-git-compare' },
  {
    id: 'caracteristicas',
    label: 'Características',
    icon: 'i-lucide-list-checks',
  },
  { id: 'endereco', label: 'Endereço', icon: 'i-lucide-map' },
  { id: 'acessos', label: 'Chaves', icon: 'i-lucide-key-round' },
  { id: 'proprietario', label: 'Proprietário', icon: 'i-lucide-user-round' },
  { id: 'publicacao', label: 'Publicação', icon: 'i-lucide-radio-tower' },
];

// Agrupa a navegação em identidade física / anúncio comercial / mídia para o
// operador não confundir o ativo com a oferta (F02 / FE-AUD-14).
export const DETAIL_GROUPS = [
  { id: 'resumo', sections: ['resumo'] },
  {
    id: 'identity',
    sections: ['identidade', 'endereco', 'mapa', 'caracteristicas', 'acessos'],
  },
  {
    id: 'listing',
    sections: [
      'valores',
      'taxas',
      'proprietario',
      'versionamento',
      'publicacao',
    ],
  },
  {
    id: 'media',
    sections: ['fotos'],
  },
];

export const SECTION_ALIASES = {
  galeria: 'fotos',
  photos: 'fotos',
  video: 'video',
  videos: 'video',
  video360: 'video360',
  tour: 'video360',
  tour360: 'video360',
  planta: 'planta',
  plantas: 'planta',
  map: 'mapa',
  valores: 'valores',
  preco: 'valores',
  precos: 'valores',
  price: 'valores',
  taxas: 'taxas',
  taxa: 'taxas',
  custos: 'taxas',
  custo: 'taxas',
  fees: 'taxas',
  costs: 'taxas',
  caracteristicas: 'caracteristicas',
  detalhes: 'caracteristicas',
  identificacao: 'identidade',
  identidade: 'identidade',
  identity: 'identidade',
  fingerprint: 'identidade',
  endereco: 'endereco',
  address: 'endereco',
  proprietario: 'proprietario',
  owner: 'proprietario',
  acessos: 'acessos',
  acesso: 'acessos',
  chaves: 'acessos',
  keys: 'acessos',
  publicacao: 'publicacao',
  portal: 'publicacao',
  portais: 'publicacao',
  publication: 'publicacao',
  lifecycle: 'versionamento',
  versao: 'versionamento',
  versoes: 'versionamento',
  version: 'versionamento',
  versions: 'versionamento',
  versionamento: 'versionamento',
  listing: 'versionamento',
};

export const PRIMARY_DETAIL_SECTIONS = [
  'resumo',
  'fotos',
  'video',
  'video360',
  'planta',
  'mapa',
  'caracteristicas',
  'identidade',
  'endereco',
];

export const SECONDARY_DETAIL_SECTIONS = [
  'resumo',
  'valores',
  'taxas',
  'proprietario',
  'publicacao',
  'versionamento',
  'acessos',
];

export const LISTING_TAG_LABELS = {
  novo: 'Anúncio novo',
  'preco-caiu': 'Baixou o preço',
  'preco-desatualizado': 'Preço desatualizado',
  preco_desatualizado: 'Preço desatualizado',
  oldUpdated: 'Preço desatualizado',
  'alta-procura': 'Anúncio com muita procura',
  'pronto-para-visita': 'Agende visita online',
  'oferece-financiamento': 'Financiamento',
  'com-condominio': 'Condomínio',
  poucas_fotos: 'Poucas fotos disponíveis',
  insufficientPhotos: 'Poucas fotos disponíveis',
  imagem_qualidade_baixa: 'Qualidade das imagens abaixo do permitido',
  imageQuality: 'Qualidade das imagens abaixo do permitido',
};

export const OWNER_CONTACT_REASONS = [
  { value: 'VISIT_SCHEDULING', label: 'Agendar visita' },
  { value: 'HOUSE_AVAILABILITY', label: 'Confirmar disponibilidade' },
  { value: 'HOUSE_FEATURES', label: 'Detalhes do imóvel' },
  { value: 'HOUSE_ENTRY_INFO', label: 'Entrada no imóvel' },
  { value: 'TENANT_HELP', label: 'Ajuda com ocupação' },
];

export const OWNER_CONTACT_TRACKING_EVENTS = {
  open: 'owner_contact_open_clicked',
  close: 'owner_contact_close_clicked',
  termsViewed: 'owner_contact_terms_and_conditions_page_viewed',
  acceptContinue: 'owner_contact_accept_continue_clicked',
  reasonViewed: 'owner_contact_reason_page_viewed',
  reasonOption: 'owner_contact_reason_option_clicked',
  request: 'owner_contact_request_clicked',
  successViewed: 'owner_contact_success_page_viewed',
  infoViewed: 'owner_contact_info_page_viewed',
  sendMessage: 'owner_contact_send_message_clicked',
  phoneCall: 'owner_contact_phone_call_clicked',
  email: 'owner_contact_email_clicked',
};

export const OWNER_CONTACT_REASON_MESSAGES = {
  VISIT_SCHEDULING: 'alinhar o agendamento de uma visita',
  HOUSE_AVAILABILITY: 'confirmar a disponibilidade do imóvel',
  HOUSE_FEATURES: 'tirar dúvidas sobre as características do imóvel',
  HOUSE_ENTRY_INFO: 'confirmar as informações de entrada no imóvel',
  TENANT_HELP: 'alinhar uma questão sobre ocupação do imóvel',
};

export const LISTING_REASONS = [
  { value: 'owner_paused', label: 'Solicitação do proprietário' },
  { value: 'visit_cancellation', label: 'Cancelamento de visita' },
  { value: 'price_review', label: 'Revisão de preço' },
  { value: 'manual_update', label: 'Atualização manual' },
];

export const LISTING_STATUS_LABELS = {
  edicao: 'Em edição',
  publicado: 'Publicado',
  despublicado: 'Despublicado',
  suspenso: 'Suspenso',
  opted_out: 'Fora da captação',
  reservado: 'Reservado',
  encerrado: 'Encerrado',
  arquivado: 'Arquivado',
};

export const RENTAL_ADMINISTRATOR_LABELS = {
  owner: 'Proprietário',
  imobiliaria: 'Imobiliária',
  terceiro: 'Terceiro',
};

export const LISTING_SOURCE_LABELS = {
  standard: 'Anúncio próprio',
  third_party: 'Anúncio de terceiro',
};

export const LISTING_DIFF_FIELD_LABELS = {
  listing_status: 'Status interno',
  available: 'Disponibilidade',
  unavailable_reason: 'Motivo',
  published_at: 'Publicado em',
  unpublished_at: 'Despublicado em',
  suspended_until: 'Suspenso até',
  price_amount: 'Preço',
  titulo: 'Título',
  descricao: 'Descrição',
  metadata: 'Metadados operacionais',
};

export const LIFECYCLE_ACTION_LABELS = {
  publish: 'publicar',
  unpublish: 'despublicar',
  suspend: 'suspender',
  relist: 'reanunciar',
};

export const PRICE_ESTIMATE_SOURCE_FALLBACK = 'QPreço Imudei';
export const PRICE_ESTIMATE_HISTORY_LIMIT = 10;
export const PRICE_ESTIMATE_CONFIDENCE_LABELS = {
  high: 'Alta confiança',
  medium: 'Confiança média',
  low: 'Baixa confiança',
  insufficient_data: 'Sem comparáveis suficientes',
};

export const DEFAULT_PORTAL = 'olx';
export const PORTAL_OPTIONS = [
  { value: 'olx', label: 'OLX' },
  { value: 'vrsync', label: 'VRSync' },
  { value: 'easybroker', label: 'EasyBroker' },
  { value: 'kenlo', label: 'Kenlo' },
];

export const PORTAL_CONNECTION_LABELS = {
  configured: 'Configurado',
  disconnected: 'Desconectado',
  degraded: 'Degradado',
  invalid: 'Inválido',
};

export const PORTAL_SYNC_STATUS_LABELS = {
  pending: 'Pendente',
  published: 'Publicado',
  failed: 'Falhou',
  unpublished: 'Retirado',
};

export const PORTAL_SYNC_ACTION_LABELS = {
  publish: 'publicar',
  update: 'atualizar',
  unpublish: 'retirar',
};

export const ENTRY_ACCESS_KIND_OPTIONS = [
  { value: 'chave_com_corretor', label: 'Chaves com o corretor' },
  { value: 'portaria', label: 'Chaves na portaria' },
  { value: 'lockbox', label: 'Lockbox' },
  { value: 'locker', label: 'Locker / HUB' },
  { value: 'password', label: 'Senha' },
  { value: 'chave_com_parceiro', label: 'Imobiliária parceira' },
  { value: 'sindico_zelador', label: 'Síndico ou zelador' },
  { value: 'chave_com_proprietario', label: 'Proprietário' },
  { value: 'chave_com_inquilino', label: 'Inquilino atual' },
  { value: 'chave_com_inquilino_externo', label: 'Inquilino externo' },
  { value: 'chave_com_inspetor', label: 'Inspetor' },
];

export const ENTRY_ACCESS_ROLE_OPTIONS = [
  { value: '', label: 'Sem papel específico' },
  { value: 'AGENT', label: 'Corretor' },
  { value: 'OWNER', label: 'Proprietário' },
  { value: 'TENANT', label: 'Inquilino' },
  { value: 'EXTERNAL_TENANT', label: 'Inquilino externo' },
  { value: 'EXTERNAL_RESPONSIBLE', label: 'Responsável externo' },
  { value: 'PARTNER', label: 'Parceiro' },
  { value: 'INSPECTOR', label: 'Inspetor' },
  { value: 'OPS', label: 'Operação' },
];

export const ENTRY_ACCESS_METADATA_FIELDS = [
  'doorman_type',
  'house_occupancy',
  'house_availability',
  'vacant_at',
  'key_type',
  'responsible_address',
];

export const TAX_FEE_HISTORY_LIMIT = 10;

export const TAX_FEE_SIMULATION_LABELS = {
  itbi: 'ITBI',
  escritura: 'Escritura',
  registro: 'Registro',
  vistoria: 'Vistoria',
  corretagem: 'Corretagem',
};

export const TAX_FEE_SIMULATION_TOTAL_LABELS = {
  acquisitionTaxes: 'Total de taxas de aquisição',
  financedValue: 'Valor financiado',
  monthlyInstallment: 'Parcela mensal estimada',
  totalFinancedCost: 'Custo total financiado',
  termMonths: 'Prazo',
  interestRateYear: 'Juros ao ano',
};

export const IDENTITY_SOURCE_LABELS = {
  imovel: 'Cadastro interno',
  legacy: 'Campos legados',
  manual: 'Manual',
  spec: 'Teste',
  properties: 'imobiliaria-api.Properties',
  'imobiliaria-api.Properties': 'imobiliaria-api.Properties',
  olx: 'OLX',
  quintoandar: 'QuintoAndar',
  zap: 'Zap Imóveis',
  viva_real: 'VivaReal',
  imovelweb: 'Imovelweb',
};

export const IDENTITY_CONFLICT_LABELS = {
  exact: 'Mesmo endereço/unidade',
  probable: 'Mesmo prédio com unidade divergente',
  possible: 'Possível duplicidade',
};

export const MEDIA_QA_REQUIREMENT_LABELS = {
  minimumPhotos: 'Mínimo de fotos',
  minimum_photos: 'Mínimo de fotos',
  cover: 'Capa',
  qa: 'QA manual',
  preflight: 'Preflight',
  rights: 'Direitos',
  sensitiveMetadata: 'Metadados sensíveis',
  sensitive_metadata: 'Metadados sensíveis',
};

export const HIGHLIGHT_PLACEMENTS = [
  { value: 'vitrine', labelKey: 'PROPERTIES.HIGHLIGHT.PLACEMENTS.VITRINE' },
  { value: 'destaque', labelKey: 'PROPERTIES.HIGHLIGHT.PLACEMENTS.DESTAQUE' },
  {
    value: 'super_destaque',
    labelKey: 'PROPERTIES.HIGHLIGHT.PLACEMENTS.SUPER',
  },
];

export const HIGHLIGHT_STATUS_META = {
  scheduled: {
    tone: 'info',
    labelKey: 'PROPERTIES.HIGHLIGHT.STATUS.SCHEDULED',
  },
  awaiting_provider_configuration: {
    tone: 'warning',
    labelKey: 'PROPERTIES.HIGHLIGHT.STATUS.AWAITING',
  },
  published: {
    tone: 'positive',
    labelKey: 'PROPERTIES.HIGHLIGHT.STATUS.PUBLISHED',
  },
  failed: { tone: 'danger', labelKey: 'PROPERTIES.HIGHLIGHT.STATUS.FAILED' },
};
